import React from "react"
import { HStack } from "@chakra-ui/react"
import { DioboxEvent } from "sharedTypes"
import useFeatureFlag from "services/featureFlags"
import AddToWallet from "./AddToWallet"
import AddToGoogleWallet from "./AddToGoogleWallet"
import AddToCalendar from "./AddToCalendar"

type Props = {
  includePassbook: boolean
  guestExternalId: string
  event: DioboxEvent
}

const GuestCardButtons = ({
  includePassbook,
  guestExternalId,
  event: { language },
  event,
}: Props) => {
  // @ts-ignore
  const isAppleDevice = typeof window !== "undefined" && Boolean(window.ApplePaySession)
  const { walletPass: walletPassEnabled } = useFeatureFlag()

  return (
    <HStack spacing={2.5}>
      {includePassbook && isAppleDevice && (
        <AddToWallet guestExternalId={guestExternalId} language={language} />
      )}
      {includePassbook && walletPassEnabled && !isAppleDevice && (
        <AddToGoogleWallet guestExternalId={guestExternalId} language={language} />
      )}
      <AddToCalendar event={event} />
    </HStack>
  )
}

export default GuestCardButtons
